.native-auth-consent {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-4, 16px);
  color: var(--text-primary);
}

.native-auth-consent p {
  margin: 0;
  overflow-wrap: anywhere;
}

.native-auth-consent__primary,
.native-auth-consent__secondary {
  width: 100%;
  min-height: 44px;
  padding: var(--spacing-3, 12px);
  border: 1px solid var(--border-color);
  border-radius: var(--radius-md, 8px);
  background: var(--bg-secondary);
  color: var(--text-primary);
  font: inherit;
  cursor: pointer;
}

.native-auth-consent__primary {
  background: var(--action-primary-bg);
  border-color: var(--action-primary-border);
  color: var(--action-primary-text);
  font-weight: 600;
}

.native-auth-consent__primary:hover:not(:disabled) {
  background: var(--action-primary-hover-bg);
  border-color: var(--action-primary-hover-border);
}

.native-auth-consent button:focus-visible {
  outline: 2px solid var(--accent-primary);
  outline-offset: 3px;
}

.native-auth-consent button:disabled {
  opacity: var(--opacity-disabled, 0.6);
  cursor: default;
}
